<template>
  <d2-container>
    <template slot="header">
      <el-input
        @keyup.enter.native="getSearch"
        style="width: 200px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入昵称或奖品"
        size="small"
        v-model="listQuery.keyword"
      ></el-input>
      <el-input
        @keyup.enter.native="getSearch"
        style="width: 200px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入用户id"
        size="small"
        v-model="listQuery.accountId"
      ></el-input>
      <el-button class="filter-item" @click="getSearch" type="primary" icon="search" size="small">搜索</el-button>
    </template>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="luckList"
    >
      <el-table-column align="center" label="记录id" width="300">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间" width="300">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="奖品id" width="300">
        <template slot-scope="scope">
          <span>{{ scope.row.giftId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="奖品名称" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.giftName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户id" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.accountId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户昵称">
        <template slot-scope="scope">
          <span>{{ scope.row.nickName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="220" fixed="right">
        <template slot-scope="scope">
          <el-button size="small" type="primary" @click="leadDrill(scope.row.accountId)" style="margin-top: 10px;">领钻记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="width:500px"
      ></el-pagination>
    </template>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { getLog } from '@/api/demo/luckDraw/index'
export default {
  name: 'lotteryRecordADdd',
  computed: {
    ...mapGetters(['elements'])
  },
  data () {
    return {
      tableKey: 0,
      luckList: [],
      total: null,
      listLoading: true, // 加载圈圈
      listQuery: {
        currentPage: 1, // 当前页数
        accountId: null, // 用户id
        pageSize: 20, // 每页显示的大小
        drawId: null, // 活动id
        keyword: null// 活动昵称和奖品
      }
    }
  },
  watch: {
    $route (to, from) {
      this.getList()
    }
  },
  created () {
    this.listQuery.drawId = this.$route.query.id
    // 抽奖活动列表
    this.getList()
  },
  methods: {
    // 抽奖活动列表
    getList () {
      let that = this
      getLog(that.listQuery).then(res => {
        that.listLoading = true
        that.luckList = res.records
        that.total = parseInt(res.total)
        that.listLoading = false
        // console.log("resres", res);
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getList()
    },
    // 搜索
    getSearch () {
      this.getList()
    },
    leadDrill (id) {
      let that = this
      console.log('id', id)
      that.$router.push({
        path: '../../../demo/user/leadDrilsl',
        query: {
          id: id
        }
      })
    }
  }
}
</script>

<style scoped>
.greed {
  color: green;
}
.red {
  color: red;
}
</style>
